import { combineReducers } from 'redux';
import Enums from 'utils/EnumsManager';
import rawData from 'views/RealTimeReport_Table/flow/reducer';
import { SET_SETTING_INFO } from './actionTypes';

const { GROUPS, AGGREGATES, OTHERS } = Enums.DROPZONES;

const initialState = {
  userInfo: null,
  settings: {
    filters: [],
    logic: '',
    [GROUPS]: [],
    [AGGREGATES]: [],
    [OTHERS]: []
  }
};

const info = (state = initialState, action) => {
  switch (action.type) {
    case SET_SETTING_INFO:
      const { settings } = action.payload;
      return {
        ...state,
        settings
      };

    default:
      return state;
  }
};

export default combineReducers({
  info,
  rawData
});



// WEBPACK FOOTER //
// ./src/views/RealTimeReport/flow/reducer.js